import typeaheadMatchContentDefaultTemplate from 'text!./Default.html';

export default [function () {
    return {
        restrict: 'E',
        template: typeaheadMatchContentDefaultTemplate,
        scope: {
            index: '=',
            match: '=',
            query: '='
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/typeahead/matchContentDirectives/Default/Default.js
// module id = 1184
// module chunks = 0